export default function BCIHero() {
  return (
    <section className="relative bg-gradient-to-b from-slate-50 to-white py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/ee9a6cc4617bc7cda0460f2c32639c10.jpg"
          alt="Brand Capital Index - Metodologia avanzata di valutazione"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/70 to-slate-900/85"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-sm font-medium text-white mb-6">
            <i className="ri-award-line text-[#E879F9] mr-2"></i>
            Metodologia Brevettata e Certificata
          </div>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
            Brand Capital
            <span className="block text-transparent bg-gradient-to-r from-[#E879F9] via-[#E879F9] to-[#22C55E] bg-clip-text">
              Index
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto leading-relaxed">
            Il primo sistema di valutazione del brand ponderato, accurato e legalmente difendibile.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-shield-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Brevetto Registrato</h3>
              <p className="text-gray-300 text-sm">Proprietà intellettuale certificata e protetta</p>
            </div>
            
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-scales-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Difendibile Legalmente</h3>
              <p className="text-gray-300 text-sm">Resistente ai controlli di revisori e banche</p>
            </div>
            
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#E879F9] to-[#22C55E] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-function-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Algoritmo proprietario</h3>
              <p className="text-gray-300 text-sm">Algoritmi avanzati e metodologia rigorosa</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}